<span class="modal-close-icon"><i class="fa-regular fa-circle-xmark" (click)="closeModal('dismiss')"></i></span>
<div class="modal-body">
  <div class="row">
    <div class="col-lg-3 col-md-3 col-sm-3">
      <div class="mt-5">
        <img class="img-thumbnail" alt="Room Image" style="width: 200px; height: 200px;" [src]="image">
      </div>
    </div>
    <div class="col-lg-9 col-md-9 col-sm-9">
      <form [formGroup]="roomForm">
        <div class="mt-5">
          <div class="form-row">
            <div class="col-md-3 mb-3">
              <label for="name">Name</label>
              <input type="text" class="form-control" formControlName="name" id="name" placeholder="Name">
            </div>
            <div class="col-md-3 mb-3">
              <label for="nameHe">Name (hebrew)</label>
              <input type="text" class="form-control" formControlName="nameHe" id="nameHe" placeholder="Name (hebrew)">
            </div>
            <div class="col-md-3 mb-3">
              <label for="type">Type</label>
              <select id="type" class="form-control" formControlName="type">
                <option *ngFor="let type of types" [value]="type">{{ type }}</option>
              </select>
            </div>
            <div class="col-md-3 mb-3">
              <label for="officeId">Office</label>
              <select id="officeId" class="form-control" formControlName="officeId">
                <option *ngFor="let office of offices" [value]="office.id">
                  {{ office.city + ', ' + office.address }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-5 mb-3" [hidden]="imageLoaded">
                <label for="image">Image</label>
                <input type="file" id="image" accept=".jpg,.gif,.png" (change)="onFileChange($event)" class="form-control">
            </div>
            <div class="col-md-5 mb-3" [hidden]="!imageLoaded">
                <label>&nbsp;</label>
                <button type="button" class="form-control btn btn-outline-secondary" (click)="deleteImage(room.id)">Delete image</button>
            </div>
            <div class="col-md-3 mb-3">
              <label for="color">Color</label>
              <select id="color" class="form-control" formControlName="color">
                <option *ngFor="let color of colors" [value]="color" [ngStyle]="getColorOptionStyle(color)">
                  {{ color }}
                </option>
              </select>
            </div>
            <div class="col-md-2 mb-3">
              <label for="area">Area (&#x33A1;)</label>
              <input type="text" class="form-control" formControlName="area" id="area">
            </div>
            <div class="col-md-2 mb-3">
              <label for="capacity">Capacity</label>
              <input type="text" class="form-control" formControlName="capacity" id="capacity">
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-12 mb-3">
              <label for="description">Description</label>
              <textarea class="form-control" rows="3" formControlName="description" id="description"></textarea>
            </div>
          </div>
          <div class="modal-buttons text-center">
            <button type="button" class="btn btn-default add-edit-button" (click)="closeModal(roomForm)">Save</button>
            <button type="button" class="btn btn-light cancel-button" (click)="closeModal('cancel')">Cancel</button>
          </div>
          <div class="form-row mt-4">
            <div class="alert alert-danger" *ngIf="errorMessage">Error: {{errorMessage}}</div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
